var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgHat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hat-cowboy-solid 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99991 1.60029C8.35991 1.60029 8.55741 1.42529 8.76991 1.24029C9.0099 1.02779 9.26741 0.800293 9.79991 0.800293C11.0324 0.800293 11.9099 4.60529 12.2474 6.34779C11.1949 6.80279 9.77241 7.20029 7.99991 7.20029C6.22741 7.20029 4.80491 6.80279 3.75241 6.34779C4.08991 4.60529 4.96741 0.800293 6.1999 0.800293C6.73241 0.800293 6.98991 1.02779 7.22991 1.24029C7.44241 1.42529 7.63991 1.60029 7.99991 1.60029ZM2.77741 6.76779C3.95741 7.38029 5.71491 8.00029 8.00241 8.00029C10.2899 8.00029 12.0474 7.38029 13.2249 6.76779C13.8449 6.44529 14.4699 6.06029 14.9774 5.57529C15.1749 5.37779 15.4824 5.34529 15.7174 5.49279C15.9549 5.64029 16.0549 5.94029 15.9649 6.20529C15.6274 7.14779 15.0049 8.01279 14.3124 8.72029C13.0924 9.97279 11.0899 11.2003 7.99991 11.2003C4.90991 11.2003 2.90991 9.97279 1.6874 8.72029C0.994905 8.01029 0.372405 7.14529 0.0349051 6.20279C-0.0550949 5.93779 0.0449051 5.63779 0.282405 5.49029C0.519905 5.34279 0.824905 5.37779 1.02241 5.57279C1.53241 6.05779 2.15491 6.44279 2.7749 6.76529L2.77741 6.76779Z",
    fill: "#FFBF00"
  }))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgHat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hat.555c13307bb63017fcd9fd1804ddeafc.svg";